







































































import {
	computed,
	defineComponent,
	ref,
	watch,
} from '@vue/composition-api';
import LoaderState from '@front-app/components/LoaderState.vue';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import TabbedNav from '@front-app/components/tabs/TabbedNav.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useTabbedNav } from '@front-app/components/tabs/useTabbedNav';
import { Routes } from '@front-app/constants/routes';
import { useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { useEventAdminStore } from '@front-app/modules/event/store/EventAdmin';
import { useEventStore } from '@front-app/modules/event/store/Event';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import { EventNotification, EventNotificationType } from '@front-app/services/EventsApi/EventModel';
import { createEventReminders, getEventNotification } from '@front-app/services/EventsApi/EventsApi';
import { isAxiosError } from '@front-app/util/axios';
import { VueConstructor } from 'vue';

const importViewEventNotificationTemplateModal = () => import(/* webpackChunkName: "event-invitation-template" */ '@front-app/views/home/event/admin/ViewEventNotificationTemplateModal.vue')
	.then((_) => _.default as VueConstructor);

enum EventAdminTabs {
	EVENT_DETAILS = 'event_details',
	MANAGE_EVENT = 'manage_event',
	// EVENT_INVITATIONS = 'event_invitations',
}

const ROUTE_TO_TAB: {[key: string]: string} = {
	[Routes.EVENT_ADMIN_DETAILS]: EventAdminTabs.EVENT_DETAILS,
	[Routes.EVENT_ADMIN_MANAGEMENT]: EventAdminTabs.MANAGE_EVENT,
	// [Routes.EVENT_ADMIN_INVITATIONS]: EventAdminTabs.EVENT_INVITATIONS,
};

const TAB_BUTTONS: ButtonNavButton[] = [
	{
		key: EventAdminTabs.EVENT_DETAILS,
		id: EventAdminTabs.EVENT_DETAILS,
		label: 'event-admin.event-details',
		to: { name: Routes.EVENT_ADMIN_DETAILS },
	},
	{
		key: EventAdminTabs.MANAGE_EVENT,
		id: EventAdminTabs.MANAGE_EVENT,
		label: 'event-page.manage-event',
		to: { name: Routes.EVENT_ADMIN_MANAGEMENT },
	},
	// {
	// 	key: EventAdminTabs.EVENT_INVITATIONS,
	// 	id: EventAdminTabs.EVENT_INVITATIONS,
	// 	label: 'event-admin.event-notifications.invitations',
	// 	to: { name: Routes.EVENT_ADMIN_INVITATIONS },
	// },
];

export default defineComponent({
	components: {
		ColumnHeader,
		ErrorCard,
		LoaderState,
		PaddedContent,
		ScrollingColumn,
		SlidingPanel,
		TabbedNav,
		ColumnContainer,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const {
			track,
			isError: isErrorFetchingEvent,
			isLoading: isFetchingEvent,
			isSuccess: isFetchingEventSuccess,
		} = useAsyncStatus();
		watch(() => props.eventId, () => {
			track(Promise.all([
				// Fetch groups to be available in the store for use in Manage Event tab
				GroupsStore.getInstance().fetchGroupsOnce(),
				useEventAdminStore().fetch(props.eventId),
				useEventStore().fetch(props.eventId),
			]));
		}, { immediate: true });

		// Back button
		const backButtonRoute = computed(() => {
			if (ctx.root.$route.params.groupId) {
				return { name: Routes.GROUP_EVENTS };
			}
			return { name: Routes.EVENTS };
		});
		const $t = useTranslate(ctx);
		const backButtonLabel = computed(() => {
			if (ctx.root.$route.params.groupId) {
				return $t('group.event.back-to-events');
			}
			return $t('event-admin.back-to-events');
		});
		// END Back button

		// Tabs
		const {
			tabButtons,
			currentTabKey,
		} = useTabbedNav(ctx, TAB_BUTTONS, ROUTE_TO_TAB);
		// END Tabs

		// Event reminder data
		const eventReminder = ref(null as unknown as EventNotification);
		const {	track: trackGetOrCreateEventReminder } = useAsyncStatus();

		async function getEventReminderData() {
			let reminderNotification = null;
			try {
				reminderNotification = await getEventNotification(props.eventId, EventNotificationType.REMINDER);
			} catch (error: unknown) {
				if (isAxiosError(error) && error.response?.status === 404) {
					await createEventReminders(props.eventId);
					reminderNotification = await getEventNotification(props.eventId, EventNotificationType.REMINDER);
				}
			}
			if (reminderNotification) {
				eventReminder.value = reminderNotification;
			}
		}
		watch(() => props.eventId, () => trackGetOrCreateEventReminder(getEventReminderData()), { immediate: true });
		// END Event reminder data

		// View event reminder template
		const viewEventNotificationTemplateModal = useAsyncModal('event-invitation-template', importViewEventNotificationTemplateModal);

		return {
			isErrorFetchingEvent,
			isFetchingEvent,
			isFetchingEventSuccess,
			// Back button
			backButtonRoute,
			backButtonLabel,
			// Tabs
			tabButtons,
			currentTabKey,
			// Event reminder data
			eventReminder,
			// View event reminder template
			EventNotificationType,
			viewEventNotificationTemplateModal,
			isViewEventNotificationTemplateModalVisible: viewEventNotificationTemplateModal.isModalVisible,
			viewEventNotificationTemplateModalView: viewEventNotificationTemplateModal.modalView,
		};
	},
});
